import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'María G.',
  quote: 'Empecé sin saber nada de internet y hoy tengo mi primera tienda online. La guía es súper clara y fácil de seguir.',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&crop=face'
}, {
  id: 2,
  name: 'Carlos R.',
  quote: 'Trabajaba 10 horas por día y no me alcanzaba. Ahora genero ingresos extra desde casa.',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=face'
}, {
  id: 3,
  name: 'Laura M.',
  quote: 'Lo mejor es que las estrategias están pensadas para Argentina. Realmente funciona.',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face'
}, {
  id: 4,
  name: 'Diego F.',
  quote: 'Siempre quise emprender pero no sabía por dónde empezar. Esta guía me dio un camino claro.',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&h=80&fit=crop&crop=face'
}, {
  id: 5,
  name: 'Andrea P.',
  quote: 'En pocas semanas pude lanzar mi primer proyecto online. Muy recomendable.',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=80&h=80&fit=crop&crop=face'
}, {
  id: 6,
  name: 'Martín S.',
  quote: 'Pude monetizar mis conocimientos de diseño. Ahora tengo clientes de todo el país.',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face'
}, {
  id: 7,
  name: 'Sofía L.',
  quote: 'El paso a paso es increíble. No te sentís perdido en ningún momento.',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=80&h=80&fit=crop&crop=face'
}, {
  id: 8,
  name: 'Javier T.',
  quote: 'Recuperé la inversión en mi primera semana de ventas. Excelente material.',
  avatar: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=80&h=80&fit=crop&crop=face'
}, {
  id: 9,
  name: 'Camila V.',
  quote: 'Me dio la confianza que necesitaba para renunciar a mi trabajo y dedicarme a lo mío.',
  avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=80&h=80&fit=crop&crop=face'
}, {
  id: 10,
  name: 'Pablo D.',
  quote: 'Directo al grano, sin vueltas. Te enseña exactamente lo que tenés que hacer.',
  avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=80&h=80&fit=crop&crop=face'
}, {
  id: 11,
  name: 'Valeria C.',
  quote: 'Ideal para mamás que queremos trabajar desde casa. Me cambió la vida.',
  avatar: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=80&h=80&fit=crop&crop=face'
}, {
  id: 12,
  name: 'Nicolás B.',
  quote: 'Las estrategias de venta son muy efectivas. Apliqué una y cerré 3 ventas en un día.',
  avatar: 'https://images.unsplash.com/photo-1527980965255-d3b416303d12?w=80&h=80&fit=crop&crop=face'
}, {
  id: 13,
  name: 'Lucía R.',
  quote: 'Pensé que era difícil, pero la guía lo hace ver muy simple. Ya tengo mi negocio funcionando.',
  avatar: 'https://images.unsplash.com/photo-1554151228-14d9def656e4?w=80&h=80&fit=crop&crop=face'
}, {
  id: 14,
  name: 'Esteban M.',
  quote: 'Vale cada peso. La cantidad de información valiosa que tiene es impresionante.',
  avatar: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=80&h=80&fit=crop&crop=face'
}, {
  id: 15,
  name: 'Florencia A.',
  quote: 'Gracias a Emprende Digital hoy soy mi propia jefa. Lo recomiendo a todo el mundo.',
  avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=80&h=80&fit=crop&crop=face'
}];
export function TestimonialsSection() {
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-91">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-92">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-50 rounded-full blur-3xl opacity-50" data-id="element-93" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-94">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-95">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-heading font-bold text-slate-900 mb-6" data-id="element-96">
            Más de 200 emprendedores ya dieron el salto digital
          </motion.h2>
          <p className="text-xl text-slate-600" data-id="element-97">
            Conocé las historias de quienes ya están generando ingresos con sus
            negocios online.
          </p>
        </div>

        {/* Masonry-like grid for testimonials */}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6" data-id="element-98">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index % 5 * 0.1
        }} className="bg-slate-50 rounded-2xl p-6 shadow-sm border border-slate-100 break-inside-avoid relative" data-id="element-99">
              <QuoteIcon className="absolute top-4 right-4 w-8 h-8 text-slate-200 rotate-180" data-id="element-100" />

              <div className="flex items-center mb-4" data-id="element-101">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-102" />)}
              </div>

              <p className="text-slate-700 mb-6 relative z-10 italic" data-id="element-103">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center" data-id="element-104">
                <img src={testimonial.avatar} alt={`Foto de ${testimonial.name}`} className="w-10 h-10 rounded-full object-cover border-2 border-white shadow-sm" data-id="element-105" />
                <div className="ml-3" data-id="element-106">
                  <h4 className="font-heading font-semibold text-slate-900 text-sm" data-id="element-107">
                    {testimonial.name}
                  </h4>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}